import {Validators} from '@angular/forms';

import {InArrayValidator} from '@spa/validators';

import {
    TradingGroupSearchModel,
    TradingGroupModel,
    TradingGroupStatusesEnum,
} from '@spa/api';

import {ComponentTypesEnum} from 'appShared/enums';
import {FilterControlInterface} from 'appShared/interfaces';
import {BaseControl, Helper, SelectControl} from 'appShared/classes';

import {ReportTableData, ReportTableConfigInterface, ReportTableColumn} from 'appShared/components';

import {TradingGroupClientTypesEnum, TradingGroupIsDefaultTypesEnum} from 'appEntries/panel/enums';

export const GroupIdSelector = 'referenceId';
export const PanelSettingsGroupsStorageId = 'PanelSettingsGroupsComponent';
export const PanelSettingsGroupsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: TradingGroupSearchModel.getStatusSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: TradingGroupSearchModel.getStatusSelector(),
                    value: TradingGroupStatusesEnum.Unspecified,
                    placeholder: 'Status',
                    validators: [Validators.required, InArrayValidator([
                        TradingGroupStatusesEnum.Active,
                        TradingGroupStatusesEnum.Inactive
                    ])],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getTradingGroupStatusV2Name(TradingGroupStatusesEnum.Unspecified),
                            value: TradingGroupStatusesEnum.Unspecified
                        },
                        {
                            label: Helper.textsHelper().getTradingGroupStatusV2Name(TradingGroupStatusesEnum.Active),
                            value: TradingGroupStatusesEnum.Active
                        },
                        {
                            label: Helper.textsHelper().getTradingGroupStatusV2Name(TradingGroupStatusesEnum.Inactive),
                            value: TradingGroupStatusesEnum.Inactive
                        },
                        {
                            label: Helper.textsHelper().getTradingGroupStatusV2Name(TradingGroupStatusesEnum.Closed),
                            value: TradingGroupStatusesEnum.Closed
                        }
                    ],
                })
            ],
            sortIndex: 1
        },
        {
            name: TradingGroupSearchModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: TradingGroupSearchModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 2,
        },
        {
            name: TradingGroupSearchModel.getBehaviorTypesSelector(),
            placeholder: 'Client Type',
            controls: [
                new SelectControl({
                    name: TradingGroupSearchModel.getBehaviorTypesSelector(),
                    value: TradingGroupStatusesEnum.Unspecified,
                    placeholder: 'Client Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.All),
                            value: TradingGroupClientTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.Individual),
                            value: TradingGroupClientTypesEnum.Individual
                        },
                        {
                            label: Helper.textsHelper().getTradingGroupClientType(TradingGroupClientTypesEnum.Company),
                            value: TradingGroupClientTypesEnum.Company
                        }
                    ]
                }),
            ],
            sortIndex: 3
        },
        {
            name: TradingGroupSearchModel.getClientIdSelector(),
            placeholder: 'Client ID',
            controls: [
                new BaseControl({
                    name: TradingGroupSearchModel.getClientIdSelector(),
                    value: null,
                    placeholder: 'Client ID',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 4,
        },
        {
            name: TradingGroupSearchModel.getClientNameSelector(),
            placeholder: 'Client Name',
            controls: [
                new BaseControl({
                    name: TradingGroupSearchModel.getClientNameSelector(),
                    value: null,
                    placeholder: 'Client Name',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 5,
        },
        {
            name: TradingGroupSearchModel.getIsDefaultSelector(),
            placeholder: 'Is Default',
            controls: [
                new SelectControl({
                    name: TradingGroupSearchModel.getIsDefaultSelector(),
                    value: TradingGroupIsDefaultTypesEnum.All,
                    placeholder: 'Is Default',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper()
                                .getTradingGroupsIsDefaultText(TradingGroupIsDefaultTypesEnum.All),
                            value: TradingGroupIsDefaultTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper()
                                .getTradingGroupsIsDefaultText(TradingGroupIsDefaultTypesEnum.Yes),
                            value: TradingGroupIsDefaultTypesEnum.Yes
                        },
                        {
                            label: Helper.textsHelper()
                                .getTradingGroupsIsDefaultText(TradingGroupIsDefaultTypesEnum.No),
                            value: TradingGroupIsDefaultTypesEnum.No
                        }
                    ]
                }),
            ],
            sortIndex: 6
        },
        {
            name: TradingGroupSearchModel.getAccountIdentifierSelector(),
            placeholder: 'Account Identifier',
            controls: [
                new BaseControl({
                    name: TradingGroupSearchModel.getAccountIdentifierSelector(),
                    value: null,
                    placeholder: 'Account Identifier',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                })
            ],
            sortIndex: 7,
        },
        // {
        //     name: '',
        //     placeholder: 'Risk Template',
        //     controls: [
        //         new SelectControl({
        //             name: '',
        //             value: null,
        //              placeholder: 'Risk Template',
        //             validators: [],
        //             componentType: ComponentTypesEnum.Select
        //         })
        //     ],
        //     shown: false,
        //     sortIndex: 8,
        // },
    ];
};

export const PanelSettingsGroupsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: TradingGroupModel.getStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: TradingGroupModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingGroupModel.getIsClientCompanySelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingGroupModel.getClientIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingGroupModel.getClientNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingGroupModel.getIsDefaultSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: TradingGroupModel.getAccountIdentifierSelector(),
            value: null,
            hidden: false
        }),
        // new ReportTableData<string>({
        //     colId: TradingGroupModel.getRiskTemplateSelector(),
        //     value: null,
        //     hidden: false
        // })
    ];
};

export const PanelSettingsGroupsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Status',
            selector: TradingGroupModel.getStatusSelector()
        }),
        new ReportTableColumn({
            label: 'Name',
            selector: TradingGroupModel.getNameSelector()
        }),
        new ReportTableColumn({
            label: 'Client Type',
            selector: TradingGroupModel.getIsClientCompanySelector()
        }),
        new ReportTableColumn({
            label: 'Client ID',
            selector: TradingGroupModel.getClientIdSelector(),
        }),
        new ReportTableColumn({
            label: 'Client Name',
            selector: TradingGroupModel.getClientNameSelector()
        }),
        new ReportTableColumn({
            label: 'Is Default',
            selector: TradingGroupModel.getIsDefaultSelector(),
        }),
        new ReportTableColumn({
            label: 'Account Identifier',
            selector: TradingGroupModel.getAccountIdentifierSelector()
        }),
        // new ReportTableColumn({
        //     label: 'Risk Template',
        //     selector: TradingGroupModel.getRiskTemplateSelector(),
        // })
    ],
    hiddenColumnIds: [],
    actionMenu: false
};
